// extracted by mini-css-extract-plugin
export default {"l_DdayIcon_main":"DdayIcon_l_DdayIcon_main__dToLR","before":"DdayIcon_before__WhEa8","dday":"DdayIcon_dday__I6Vey","after":"DdayIcon_after__ap75c"};